// The memberships' own small parts, drawn with ui-web's (BL-189): a form's foot, and the renewal terms
// with the customer's yes. Selling (SellMembership.tsx), the member's sheet (MemberDetail.tsx) and its
// forms (MemberStatus.tsx, Billing.tsx, AutoRenew.tsx) share them; their lines are memberships.css's.
import type { ReactNode } from 'react';
import { Button, Checkbox } from '@flowology/ui-web/fl';
import type { RenewalTerms } from './model.ts';
import './memberships.css';

/** A form's foot, as the old forms had it: Back, then its action (dashed while it works), then why it
 * didn't save. */
export function FormActs({
  back,
  backLabel = 'Back',
  busy,
  error,
  label,
  isDisabled,
  onSave,
}: {
  back: () => void;
  backLabel?: string;
  busy: boolean;
  error: string | null;
  label: string | null;
  isDisabled?: boolean;
  onSave: () => void;
}) {
  return (
    <>
      <div className="bp-member-acts">
        <Button onPress={back}>{backLabel}</Button>
        {label && (
          <Button variant="primary" isBusy={busy} isDisabled={!busy && isDisabled} onPress={onSave}>
            {label}
          </Button>
        )}
      </div>
      {error && (
        <p className="bp-member-bad" role="alert">
          {error}
        </p>
      )}
    </>
  );
}

/** The plan's renewal terms, word for word, and the customer's yes to them (F-27). */
export function TermsAgreed({
  terms,
  error,
  agreed,
  onAgree,
  children,
}: {
  terms: Pick<RenewalTerms, 'text'> | null;
  error: string | null;
  agreed: boolean;
  onAgree: (agreed: boolean) => void;
  /** What's done with them, inside the group (Cancel, Turn auto-renew on). */
  children?: ReactNode;
}) {
  return (
    <div className="bp-member-terms" role="group" aria-label="Renewal terms">
      {error ? (
        <p className="bp-member-bad">{error}</p>
      ) : !terms ? (
        <p className="bp-member-quiet">Getting the renewal terms…</p>
      ) : (
        <>
          <p className="bp-member-terms-text">{terms.text}</p>
          <Checkbox isSelected={agreed} onChange={onAgree}>
            The customer agrees to these terms
          </Checkbox>
        </>
      )}
      {children}
    </div>
  );
}
